import autoOffer from './auto-offer.module'

export default {
  autoOffer,
}
